import { action, atom } from '@reatom/framework'

import { TradeApiClient } from '@blade/trade-api-client'
import { environmentAtom } from '@root/shared'

import { createCustomFetch } from './lib/custom-fetch'

interface TradeApiClientDependency {
  tradeApiClient: TradeApiClient<unknown>
}

/**
 * We use this atom as means to provide dependencies, so it's fine to cast to any here
 */
export const tradeApiClientAtom = atom<TradeApiClientDependency>(
  {} as TradeApiClientDependency,
  'tradeApiClientAtom',
)

export const initializeTradeApiClient = action((ctx) => {
  const environment = ctx.get(environmentAtom)

  const tradeApiClient = new TradeApiClient({
    baseUrl: environment.tradeApiHost,
    baseApiParams: { credentials: 'include' },
    customFetch: createCustomFetch(),
  })

  tradeApiClientAtom(ctx, {
    tradeApiClient,
  })
}, 'initializeTradeApiClient')
